<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Atualizar Senha</p>
    </header>
    <section class="modal-card-body">
      <div class="row">
        <div class="col-12">
          <h1>O Clube está de cara nova!</h1>
          <p>
            Com a nova atualização, implementamos melhorias de segurança e
            portanto precisamos que você cadastre uma nova senha.
            <br />Sua senha nova deve ter no mínimo 6 caracteres!
          </p>
        </div>
        <div class="col-12">
          <app-input
            v-model="current_password"
            :errors="errors.current_password"
            label="Senha Atual"
            type="password"
          ></app-input>
        </div>
        <div class="col-6">
          <app-input
            v-model="password"
            :errors="errors.password"
            label="Nova Senha"
            type="password"
          ></app-input>
        </div>
        <div class="col-6">
          <app-input
            v-model="password_confirmation"
            :errors="errors.password_confirmation"
            label="Confirmar Nova Senha"
            type="password"
          ></app-input>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button
        @click="updatePassword()"
        :disabled="$v.$invalid || isSaving"
        v-app-button
      >
        Atualizar senha
      </button>
    </footer>
  </div>
</template>

<script>
import ClientService from '@/services/client.service';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'app-modal',
  data: () => {
    return {
      isSaving: false,
      errors: {},
      current_password: null,
      password: null,
      password_confirmation: null,
    };
  },
  validations: {
    current_password: { required },
    password: { required, minLength: minLength(6) },
    password_confirmation: { sameAsPassword: sameAs('password') },
  },
  methods: {
    updatePassword() {
      const { current_password, password, password_confirmation } = this;

      this.isSaving = true;
      ClientService.updatePassword({
        current_password,
        password,
        password_confirmation,
      })
        .then(() => {
          this.toastify('Senha atualizada com sucesso!');
          this.$parent.close();
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) {
            this.errors = errors;
          } else if (response.status == 403) {
            this.toastify('Senha atual incorreta.', 'error');
          } else {
            this.toastify(
              message || 'Erro ao tentar atualizar senha.',
              'error'
            );
          }
        })
        .finally(() => (this.isSaving = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-card {
  &-head {
    background: var(--color-secondary);

    p {
      color: #fff;
    }
  }

  &-body {
    h1 {
      font-family: var(--font-family-secondary);
      font-weight: 600;
      font-size: 2rem;
      color: var(--color-primary);
      text-align: center;
      margin-bottom: 8px;
    }

    p {
      font-size: 1.1rem;
      color: var(--text-color-medium);
      text-align: center;
      margin-bottom: 32px;
    }
  }
}
</style>
